// @flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Text } from 'gestalt';

type Props = {|
  allDigits?: boolean,
  views: number,
|};

export default function VideoViews({ allDigits = false, views: videoViews }: Props) {
  return (
    <Text color="gray" size="sm">
      {interpolateNamedTemplate(
        i18n.ngettext(
          '{{ videoViewFormat }} total view',
          '{{ videoViewFormat }} total views',
          videoViews,
          'Label for the number of video views a video creator has',
        ),
        {
          videoViewFormat: (
            <Text color="gray" inline key="video_views" size="sm" weight="bold">
              <PrettyNumber
                value={videoViews}
                shortform={!allDigits}
                shortformMaximumFractionDigits={!allDigits ? 1 : undefined}
              />
            </Text>
          ),
        },
      )}
    </Text>
  );
}
